import React from 'react';
import PropTypes from 'prop-types';
import { usePopupConfirmButton } from '../../../hooks/usePopupConfirmButton';
import { Button, Popup } from 'semantic-ui-react';

export const ButtonWithConfirmation = ({
  confirmButtonText,
  confirmButtonColor,
  buttonText,
  buttonIcon,
  disabled,
  loading,
  onConfirmation,
}) => {
  const { isOpen, open, close } = usePopupConfirmButton();

  const handleConfirmation = (e) => {
    e.preventDefault();
    close();
    onConfirmation(e);
  };

  return (
    <Popup
      trigger={
        <Button
          primary
          content={buttonText}
          floated="right"
          icon={buttonIcon}
          loading={loading}
          disabled={loading || disabled}
        />
      }
      content={
        <Button
          color={confirmButtonColor}
          content={confirmButtonText}
          onClick={(e) => handleConfirmation(e)}
        />
      }
      on={['click']}
      position="top right"
      open={isOpen}
      onClose={close}
      onOpen={open}
    />
  );
};

ButtonWithConfirmation.propTypes = {
  confirmButtonText: PropTypes.string,
  confirmButtonColor: PropTypes.string,
  buttonText: PropTypes.string,
  buttonIcon: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onConfirmation: PropTypes.func.isRequired,
};

ButtonWithConfirmation.defaultProps = {
  confirmButtonText: 'CONFIRM',
  confirmButtonColor: 'red',
  buttonText: 'Submit',
  buttonIcon: null,
  disabled: false,
  loading: false,
};

export default ButtonWithConfirmation;
